import { formatNumber, formatNumberWithCommas } from '../../../../../utils/UtilReport';
import { CRM_SALES_FORCE_OBJECT, MERGE_REPORT_NAME, REPORT_NAMES, SALES_FORCE_OBJECT } from '../../../../../constants';
import CIcon from '@coreui/icons-react';
import { capitalizeFirstLetter, convertReportDuration, filterObjectValuesNotNull, getFriendlyNameTooltip } from '../../../../../utils';
import Tippy from '@tippyjs/react';
import { Skeleton } from '@progress/kendo-react-indicators';
import { CSpinner } from '@coreui/react';
import { INTENT_PROPERTIES_STORE, MAPPING_INTENT_OBJECT_ID } from '../../../../../constants/intent-rules';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import { updateIntentCell } from '../../../../../actions/subscriber';
import PropTypes from 'prop-types';

export const Tag = ({ item, onClick, tagUserSourceDetail }) => {
     return (
          <span
               className={`tag d-flex flex-wrap align-items-center ${typeof onClick !== 'function' && !tagUserSourceDetail ? 'no-click' : ''}`}
               onClick={onClick}
          >
               {item}
          </span>
     );
};

export const TagStatus = ({ item, onClick, tagUserSourceDetail, color }) => {
     return (
          <div className={`tooltip-tag`}>
               <span
                    className={`${color} badge d-flex flex-wrap align-items-center ${typeof onClick !== 'function' && !tagUserSourceDetail ? 'no-click' : ''}`}
                    onClick={onClick}
               >
                    {item}
               </span>
          </div>
     );
};

const getFieldData = (data, field, fieldName) => {
     if (typeof data[fieldName] !== 'undefined') {
          return data[fieldName];
     }
     return data[`${field.split('_')[0]}_${fieldName}`];
};

export const SessionCount = (props, handleEnterToLink, handleLinkToOtherReport, reportName, originalField) => {
     const { style, className, id, field, dataItem } = props;
     const sessionCount = getFieldData(dataItem, field, originalField);
     if (sessionCount > 0) {
          return (
               <td
                    style={style}
                    className={`clickable ${className}`}
                    tabIndex={0}
                    data-keyboardnavid={id}
                    onKeyPress={(e) => handleEnterToLink(e)}
                    onClick={() => {
                         return handleLinkToOtherReport(originalField, { ...dataItem }, field);
                    }}
               >{`${formatNumber(sessionCount)}`}</td>
          );
     }

     return <td {...{ style, className }} tabIndex={0} data-keyboardnavid={id}>{`${formatNumber(sessionCount)}`}</td>;
};

export const LinkMetricCount = (props, handleEnterToLink, handleLinkToOtherReport, reportName, originalField) => {
     const { style, className, id, field, dataItem } = props;
     const valueCount = getFieldData(dataItem, field, originalField);
     if (valueCount > 0 && MERGE_REPORT_NAME.includes(reportName)) {
          return (
               <td
                    style={style}
                    className={`clickable ${className}`}
                    tabIndex={0}
                    data-keyboardnavid={id}
                    onKeyPress={(e) => handleEnterToLink(e)}
                    onClick={() => {
                         return handleLinkToOtherReport(originalField, { ...dataItem }, field);
                    }}
               >{`${formatNumber(valueCount)}`}</td>
          );
     }

     return <td {...{ style, className }} tabIndex={0} data-keyboardnavid={id}>{`${formatNumber(valueCount)}`}</td>;
};

export const UserCount = (props, handleEnterToLink, handleLinkToOtherReport, reportName) => {
     const { style, className, id, field, dataItem } = props;
     const userCount = getFieldData(dataItem, field, 'userCount');

     if (userCount > 0) {
          return (
               <td
                    style={style}
                    className={`clickable ${className}`}
                    tabIndex={0}
                    data-keyboardnavid={id}
                    onKeyPress={(e) => handleEnterToLink(e)}
                    onClick={() => {
                         return handleLinkToOtherReport('userCount', { ...dataItem }, field);
                    }}
               >{`${formatNumber(userCount)}`}</td>
          );
     }

     return <td {...{ style, className }} tabIndex={0} data-keyboardnavid={id}>{`${formatNumber(userCount)}`}</td>;
};

export const RevealedCompany = (props, handleEnterToLink, handleLinkToOtherReport, reportName) => {
     const { style, className, id, field, dataItem } = props;
     const revealedCompany = getFieldData(dataItem, field, field);

     if (revealedCompany > 0) {
          return (
               <td
                    style={style}
                    className={`clickable ${className}`}
                    tabIndex={0}
                    data-keyboardnavid={id}
                    onKeyPress={(e) => handleEnterToLink(e)}
                    onClick={() => {
                         return handleLinkToOtherReport('revealedCompany', { ...dataItem }, field);
                    }}
               >{`${formatNumber(revealedCompany)}`}</td>
          );
     }

     return <td {...{ style, className }} tabIndex={0} data-keyboardnavid={id}>{`${formatNumber(revealedCompany)}`}</td>;
};

export const PeopleCount = (props, handleEnterToLink, handleLinkToOtherReport, reportName) => {
     const { style, className, id, field, dataItem } = props;
     const peopleCount = getFieldData(dataItem, field, field);

     if (peopleCount > 0) {
          return (
               <td
                    style={style}
                    className={`clickable ${className}`}
                    tabIndex={0}
                    data-keyboardnavid={id}
                    onKeyPress={(e) => handleEnterToLink(e)}
                    onClick={() => {
                         return handleLinkToOtherReport('peopleCount', { ...dataItem }, field);
                    }}
               >{`${formatNumber(peopleCount)}`}</td>
          );
     }

     return <td {...{ style, className }} tabIndex={0} data-keyboardnavid={id}>{`${formatNumber(peopleCount)}`}</td>;
};

export const EventCount = (props, reportName) => {
     const { style, className, id, field, dataItem } = props;
     const eventCount = getFieldData(dataItem, field, 'eventCount');

     if (
          [REPORT_NAMES.EVENT_DETAILS, REPORT_NAMES.PAGE_VIEW_DETAILS, REPORT_NAMES.CONVERSION_EVENTS, REPORT_NAMES.FORM_SUBMISSION_EVENTS].includes(
               reportName
          )
     ) {
          return (
               <td {...{ style, className }} tabIndex={0} data-keyboardnavid={id}>
                    {formatNumber(eventCount)}
               </td>
          );
     }
     return (
          <td {...{ style, className }} tabIndex={0} data-keyboardnavid={id}>
               {formatNumber(eventCount)}
          </td>
     );
};

export const PersonCreated = (props, handleEnterToLink, handleLinkToOtherReport) => {
     const { style, className, id, field, dataItem } = props;
     const personCreatedCount = getFieldData(dataItem, field, 'personCreatedCount');
     const personId = getFieldData(dataItem, field, 'personId');

     if (personCreatedCount === 1) {
          return (
               <td
                    style={style}
                    className={`clickable ${className}`}
                    tabIndex={0}
                    data-keyboardnavid={id}
                    onKeyPress={(e) => handleEnterToLink(e)}
                    onClick={() => handleLinkToOtherReport('personCreatedCount', { id: personId })}
               >
                    {formatNumber(personCreatedCount)}
               </td>
          );
     }

     return (
          <td {...{ style, className }} tabIndex={0} data-keyboardnavid={id}>
               {formatNumber(personCreatedCount)}
          </td>
     );
};

export const ActiveUser = (props, handleEnterToLink, handleLinkToOtherReport) => {
     const { style, className, id, field, dataItem } = props;
     const activeUser = getFieldData(dataItem, field, 'activeUser');
     const landingPage = getFieldData(dataItem, field, 'landingPage');
     const exitPage = getFieldData(dataItem, field, 'exitPage');

     if (activeUser > 0) {
          return (
               <td
                    style={style}
                    className={`clickable ${className}`}
                    tabIndex={0}
                    data-keyboardnavid={id}
                    onKeyPress={(e) => handleEnterToLink(e)}
                    onClick={() => handleLinkToOtherReport('activeUser', { landingPage, exitPage })}
               >
                    {activeUser}
               </td>
          );
     }

     return (
          <td {...{ style, className }} tabIndex={0} data-keyboardnavid={id}>
               {activeUser}
          </td>
     );
};

export const ActiveUserCount = (props, handleEnterToLink, handleLinkToOtherReport, reportName) => {
     const { style, className, id, field, dataItem } = props;
     const activeUserCount = getFieldData(dataItem, field, 'activeUserCount');
     const userSourceFirst = getFieldData(dataItem, field, 'userSourceFirst');
     const userSourceLast = getFieldData(dataItem, field, 'userSourceLast');
     const userSource = getFieldData(dataItem, field, 'userSource');
     const conversionName = getFieldData(dataItem, field, 'conversionName');

     if (activeUserCount > 0) {
          return (
               <td
                    style={style}
                    className={`clickable ${className}`}
                    tabIndex={0}
                    data-keyboardnavid={id}
                    onKeyPress={(e) => handleEnterToLink(e)}
                    onClick={() => {
                         if (reportName === REPORT_NAMES.CONVERSION_NAME_DETAILS) {
                              return handleLinkToOtherReport('activeUserCount', { conversionName });
                         } else {
                              return handleLinkToOtherReport('activeUserCount', {
                                   userSourceFirst,
                                   userSourceLast,
                                   userSource,
                              });
                         }
                    }}
               >
                    {formatNumber(activeUserCount)}
               </td>
          );
     }

     return (
          <td {...{ style, className }} tabIndex={0} data-keyboardnavid={id}>
               {formatNumber(activeUserCount)}
          </td>
     );
};

export const ViewDetail = (
     data,
     { style, className, id },
     filterDimensions,
     onClickShowDetailEvent,
     onClickShowDetailEventECommerce,
     onClickShowDetailUser,
     onClickShowDetailSession,
     onClickShowDetailPerson,
     onClickShowDetailForm,
     onClickShowDetailCompany,
     onClickShowDetailSF,
) => {
     switch (filterDimensions[0].value) {
          case 'eventId':
               return (
                    <td
                         style={style}
                         className={`${className} view-detail`}
                         tabIndex={0}
                         data-keyboardnavid={id}
                         onClick={() => onClickShowDetailEvent({ ...data })}
                    >
                         View
                    </td>
               );
          case 'eventECommerceId':
               return (
                    <td
                         style={style}
                         className={`${className} view-detail`}
                         tabIndex={0}
                         data-keyboardnavid={id}
                         onClick={() => onClickShowDetailEventECommerce({ ...data })}
                    >
                         View
                    </td>
               );
          case 'userId':
               return (
                    <td
                         style={style}
                         className={`${className} view-detail`}
                         tabIndex={0}
                         data-keyboardnavid={id}
                         onClick={() => onClickShowDetailUser({ ...data })}
                    >
                         View
                    </td>
               );
          case 'sessionId':
               return (
                    <td
                         style={style}
                         className={`${className} view-detail`}
                         tabIndex={0}
                         data-keyboardnavid={id}
                         onClick={() => onClickShowDetailSession({ ...data })}
                    >
                         View
                    </td>
               );
          case 'personId':
               return (
                    <td
                         style={style}
                         className={`${className} view-detail`}
                         tabIndex={0}
                         data-keyboardnavid={id}
                         onClick={() => onClickShowDetailPerson({ ...data })}
                    >
                         View
                    </td>
               );
          case 'formId':
          case 'formHostNamePathName':
               return (
                    <td
                         style={style}
                         className={`${className} view-detail`}
                         tabIndex={0}
                         data-keyboardnavid={id}
                         onClick={() => onClickShowDetailForm({ ...data })}
                    >
                         View
                    </td>
               );
          case 'companyId':
               return (
                    <td
                         style={style}
                         className={`${className} view-detail`}
                         tabIndex={0}
                         data-keyboardnavid={id}
                         onClick={() => onClickShowDetailCompany({ ...data })}
                    >
                         View
                    </td>
               );
          default:
               if (filterDimensions[0].value) {
                    const object = SALES_FORCE_OBJECT[filterDimensions[0].value] || filterDimensions[0].value.replace('__cID', '__c')
                    const crmId = data[CRM_SALES_FORCE_OBJECT[filterDimensions[0].value]] || data.crmCustomObjectID
                    return (
                         <td
                              style={style}
                              className={`${className} view-detail`}
                              tabIndex={0}
                              data-keyboardnavid={id}
                              onClick={() => onClickShowDetailSF({ ...data, crmId, object })}
                         >
                              View
                         </td>
                    )
               }
               return <td>No Data</td>;
     }
};

export const ViewProfileById = (
     data,
     { style, className, id },
     filterDimensions,
     onClickShowDetailUser,
     onClickShowDetailSession,
     onClickShowDetailPerson,
     onClickShowDetailForm,
     onClickShowDetailCompany,
     property,
     originalField
) => {
     const { userId, sessionId, personId, companyId, formId } = data;
     if (data[property].toLowerCase() === 'none' || !data[property])
          return <td {...{ style, className }} tabIndex={0} data-keyboardnavid={id}>{`${formatNumber(data[property] || 'none')}`}</td>;
     switch (originalField) {
          case filterDimensions[0].value:
               return <td {...{ style, className }} tabIndex={0} data-keyboardnavid={id}>{`${formatNumber(data[property])}`}</td>;
          case 'userId':
               if (filterDimensions[0].value === 'personId') {
                    const userList = userId.split(',');
                    return (
                         <td {...{ style, className }} className={`view-detail list-tags ${className}`} tabIndex={0} data-keyboardnavid={id}>
                              <div className="tags-wrapper">
                                   {userList.map((item, key) => (
                                        <Tag item={item} key={key} onClick={() => onClickShowDetailUser({ userId: item })} />
                                   ))}
                              </div>
                         </td>
                    );
               }
               return (
                    <td style={style} className={`${className} view-detail list-tags`} tabIndex={0} data-keyboardnavid={id}>
                         <div className="tags-wrapper">
                              <Tag item={userId} onClick={() => onClickShowDetailUser({ ...data })} />
                         </div>
                    </td>
               );
          case 'sessionId':
               return (
                    <td style={style} className={`${className} view-detail list-tags`} tabIndex={0} data-keyboardnavid={id}>
                         <div className="tags-wrapper">
                              <Tag item={sessionId} onClick={() => onClickShowDetailSession({ ...data })} />
                         </div>
                    </td>
               );
          case 'personId':
               return (
                    <td style={style} className={`${className} view-detail list-tags`} tabIndex={0} data-keyboardnavid={id}>
                         <div className="tags-wrapper">
                              {personId === 'None' ? (
                                   <Tag item={personId} />
                              ) : (
                                   <Tag item={personId} onClick={() => onClickShowDetailPerson({ ...data })} />
                              )}
                         </div>
                    </td>
               );
          case 'formId':
          case 'formHostNamePathName':
               return (
                    <td style={style} className={`${className} view-detail list-tags`} tabIndex={0} data-keyboardnavid={id}>
                         <div className="tags-wrapper">
                              <Tag item={formId} onClick={() => onClickShowDetailForm({ ...data })} />
                         </div>
                    </td>
               );
          case 'companyId':
               return (
                    <td style={style} className={`${className} view-detail list-tags`} tabIndex={0} data-keyboardnavid={id}>
                         <div className="tags-wrapper">
                              <Tag item={companyId} onClick={() => onClickShowDetailCompany({ ...data })} />
                         </div>
                    </td>
               );
          default:
               return <td>No Data</td>;
     }
};

//----------------------------------------------------------------
function transformObject(obj) {
     const result = {};

     for (const key in obj) {
          if (key !== 'name' && key !== 'createdAt') {
               const value = obj[key];

               if (Array.isArray(value)) {
                    value.forEach((nestedObj) => {
                         const nestedKey = Object.keys(nestedObj)[0];
                         const nestedValue = nestedObj[nestedKey];
                         result[nestedKey] = nestedValue;
                    });
               } else {
                    result[key] = value;
               }
          }
     }

     return result;
}

// Generic grouping function for education and otherRoles
const groupByField = (data, groupKey) => {
     if (!data || !Array.isArray(data) || data.length === 0) return null;

     const grouped = {};
     const displayNames = {};

     data.forEach((item) => {
          let key = item[groupKey];

          // For education: if schoolName is null, use fieldOfStudy or degree
          if (!key && groupKey === 'schoolName') {
               key = item.fieldOfStudy || item.degree || 'Unknown';
          } else if (!key) {
               key = 'Unknown';
          }

          const normalizedKey = key.toLowerCase();

          if (!grouped[normalizedKey]) {
               grouped[normalizedKey] = [];
               displayNames[normalizedKey] = key;
          }
          grouped[normalizedKey].push(item);
     });

     const result = {};
     for (const normalizedKey in grouped) {
          result[displayNames[normalizedKey]] = grouped[normalizedKey];
     }

     return result;
};

// Generic tooltip renderer for grouped education, otherRoles, volunteering, or certifications
const renderGroupedItemTooltip = (groupName, itemsList, key, type) => {
     const isEducation = type === 'education';
     const isVolunteering = type === 'volunteering';
     const isCertifications = type === 'certifications';
     const hasMultipleItems = itemsList.length > 1;

     // Helper to check if value is valid (not null, not empty, not 'Unknown')
     const isValidValue = (value) => value && value !== 'Unknown';

     // Check if education item has any non-null values
     const hasEducationData = (item) => {
          return isValidValue(item.fieldOfStudy) || isValidValue(item.degree) || isValidValue(item.startYear) || isValidValue(item.endYear);
     };

     // Check if otherRoles item has any non-null values
     const hasOtherRolesData = (item) => {
          return isValidValue(item.title) || isValidValue(item.domain) ||
               isValidValue(item.seniority) || isValidValue(item.jobFunctions) || isValidValue(item.employmentType) || isValidValue(item.startDate) || isValidValue(item.endDate);
     };

     // Check if volunteering item has any non-null values
     const hasVolunteeringData = (item) => {
          return isValidValue(item.role) || isValidValue(item.summary) || isValidValue(item.currentRole) || isValidValue(item.startDate) || isValidValue(item.endDate);
     };

     // Check if certifications item has any non-null values
     const hasCertificationsData = (item) => {
          return isValidValue(item.title) || isValidValue(item.summary) || isValidValue(item.companyName) || isValidValue(item.month) || isValidValue(item.year);
     };

     // Check if all items in the list have null values
     const hasAnyData = itemsList.some((item) => {
          if (isEducation) return hasEducationData(item);
          if (isVolunteering) return hasVolunteeringData(item);
          if (isCertifications) return hasCertificationsData(item);
          return hasOtherRolesData(item);
     });

     const renderEducationItem = (item, index) => {
          const prefix = hasMultipleItems ? `${index + 1}. ` : '';

          return (
               <>
                    <tr key={`fieldOfStudy-${index}`}>
                         <td className="title4">{prefix}Field of study:&nbsp;</td>
                         <td className="content">{item.fieldOfStudy || 'Unknown'}</td>
                    </tr>
                    <tr key={`degree-${index}`}>
                         <td className="title4">Degree:&nbsp;</td>
                         <td className="content">{item.degree || 'Unknown'}</td>
                    </tr>
                    <tr key={`startDate-${index}`}>
                         <td className="title4">Start Date:&nbsp;</td>
                         <td className="content">{item.startYear || 'Unknown'}</td>
                    </tr>
                    <tr key={`endDate-${index}`}>
                         <td className="title4">End Date:&nbsp;</td>
                         <td className="content">{item.endYear || 'Unknown'}</td>
                    </tr>
                    {hasMultipleItems && index < itemsList.length - 1 && (
                         <tr key={`separator-${index}`}>
                              <td colSpan="2" style={{ height: '8px' }}></td>
                         </tr>
                    )}
               </>
          );
     };

     const renderOtherRolesItem = (item, index) => {
          const prefix = hasMultipleItems ? `${index + 1}. ` : '';
          const startDate = item.startDate?.value || item.startDate;
          const endDate = item.endDate?.value || item.endDate;
          const endDateDisplay = endDate || (item.currentRole === 'Yes' ? 'Present' : 'Unknown');

          return (
               <>
                    <tr key={`title-${index}`}>
                         <td className="title4">{prefix}Title:&nbsp;</td>
                         <td className="content">{item.title || 'Unknown'}</td>
                    </tr>
                    <tr key={`domain-${index}`}>
                         <td className="title4">Domain:&nbsp;</td>
                         <td className="content">{item.domain || 'Unknown'}</td>
                    </tr>
                    <tr key={`companyLinkedinUrl-${index}`}>
                         <td className="title4">Company Linkedin URL:&nbsp;</td>
                         <td className="content">{item.companyLinkedinUrl || 'Unknown'}</td>
                    </tr>
                    <tr key={`currentRole-${index}`}>
                         <td className="title4">Current Role:&nbsp;</td>
                         <td className="content">{item.currentRole !== undefined && item.currentRole !== null ? item.currentRole : 'Unknown'}</td>
                    </tr>
                    <tr key={`seniority-${index}`}>
                         <td className="title4">Seniority:&nbsp;</td>
                         <td className="content">{item.seniority || 'Unknown'}</td>
                    </tr>
                    <tr key={`jobFunctions-${index}`}>
                         <td className="title4">Job Functions:&nbsp;</td>
                         <td className="content">{item.jobFunctions || 'Unknown'}</td>
                    </tr>
                    <tr key={`employmentType-${index}`}>
                         <td className="title4">Employment Type:&nbsp;</td>
                         <td className="content">{item.employmentType || 'Unknown'}</td>
                    </tr>
                    <tr key={`startDate-${index}`}>
                         <td className="title4">Start Date:&nbsp;</td>
                         <td className="content">{startDate || 'Unknown'}</td>
                    </tr>
                    <tr key={`endDate-${index}`}>
                         <td className="title4">End Date:&nbsp;</td>
                         <td className="content">{endDateDisplay}</td>
                    </tr>
                    {hasMultipleItems && index < itemsList.length - 1 && (
                         <tr key={`separator-${index}`}>
                              <td colSpan="2" style={{ height: '8px' }}></td>
                         </tr>
                    )}
               </>
          );
     };

     const renderVolunteeringItem = (item, index) => {
          const prefix = hasMultipleItems ? `${index + 1}. ` : '';
          const startDate = item.startDate?.value || item.startDate;
          const endDate = item.endDate?.value || item.endDate;

          return (
               <>
                    <tr key={`role-${index}`}>
                         <td className="title4">{prefix}Role:&nbsp;</td>
                         <td className="content">{item.role || 'Unknown'}</td>
                    </tr>
                    <tr key={`summary-${index}`}>
                         <td className="title4">Summary:&nbsp;</td>
                         <td className="content">{item.summary || 'Unknown'}</td>
                    </tr>
                    <tr key={`currentRole-${index}`}>
                         <td className="title4">Current Role:&nbsp;</td>
                         <td className="content">{item.currentRole !== undefined && item.currentRole !== null ? item.currentRole : 'Unknown'}</td>
                    </tr>
                    <tr key={`startDate-${index}`}>
                         <td className="title4">Start Date:&nbsp;</td>
                         <td className="content">{startDate || 'Unknown'}</td>
                    </tr>
                    <tr key={`endDate-${index}`}>
                         <td className="title4">End Date:&nbsp;</td>
                         <td className="content">{endDate || 'Unknown'}</td>
                    </tr>
                    {hasMultipleItems && index < itemsList.length - 1 && (
                         <tr key={`separator-${index}`}>
                              <td colSpan="2" style={{ height: '8px' }}></td>
                         </tr>
                    )}
               </>
          );
     };

     const renderCertificationsItem = (item, index) => {
          const prefix = hasMultipleItems ? `${index + 1}. ` : '';

          return (
               <>
                    <tr key={`company-${index}`}>
                         <td className="title4">{prefix}Company Name:&nbsp;</td>
                         <td className="content">{item.companyName || 'Unknown'}</td>
                    </tr>
                    <tr key={`summary-${index}`}>
                         <td className="title4">Summary:&nbsp;</td>
                         <td className="content">{item.summary || 'Unknown'}</td>
                    </tr>
                    <tr key={`month-${index}`}>
                         <td className="title4">Month:&nbsp;</td>
                         <td className="content">{item.month || 'Unknown'}</td>
                    </tr>
                    <tr key={`year-${index}`}>
                         <td className="title4">Year:&nbsp;</td>
                         <td className="content">{item.year || 'Unknown'}</td>
                    </tr>
                    {hasMultipleItems && index < itemsList.length - 1 && (
                         <tr key={`separator-${index}`}>
                              <td colSpan="2" style={{ height: '8px' }}></td>
                         </tr>
                    )}
               </>
          );
     };

     const buildTooltipContent = () => {
          if (!hasAnyData) {
               return (
                    <div className="tooltip-content">
                         <span>Data not found, therefore no information is displayed.</span>
                    </div>
               );
          }

          return (
               <div className="tooltip-content" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    <table>
                         <tbody>
                              {itemsList.map((item, index) => {
                                   if (isEducation) {
                                        return renderEducationItem(item, index);
                                   } else if (isVolunteering) {
                                        return renderVolunteeringItem(item, index);
                                   } else if (isCertifications) {
                                        return renderCertificationsItem(item, index);
                                   } else {
                                        return renderOtherRolesItem(item, index);
                                   }
                              })}
                         </tbody>
                    </table>
               </div>
          );
     };

     return (
          <div className="tags-wrapper" key={key}>
               <Tippy
                    content={buildTooltipContent()}
                    placement="top"
                    maxWidth="900px"
                    theme="user-source"
                    hideOnClick="false"
                    delay={[200, null]}
                    interactive="true"
                    appendTo={() => document.body}
               >
                    <span>
                         <Tag item={groupName} tagUserSourceDetail={true} />
                    </span>
               </Tippy>
          </div>
     );
};

const renderTooltipUserSource = (item, key, originalField) => {
     let nameField = item?.name || item?.companyName || item?.email || item?.schoolName || item?.title || item?.recommenderName;
     let isCustomType = ['enrichType', 'dataSources'].includes(originalField)
     return (
          <div className="tags-wrapper" key={key}>
               <Tippy
                    content={
                         <div className="tooltip-content">
                              <table>
                                   <tbody>
                                        {
                                             !isCustomType  ?
                                                  Object.keys(item).map(
                                                       (key) =>
                                                            key !== 'name' &&
                                                            key !== 'createdAt' &&
                                                            (key !== 'sourceUTMs' && key !== 'clickIds' && key !== 'timestamp' && key !== 'noted' && key !== 'startDate' && key !== 'endDate' && item[key] !== '' ? (
                                                                 item[key] !== null && item[key] !== undefined ? (
                                                                      <tr key={`${key}`}>
                                                                           <td className="title4">
                                                                                {getFriendlyNameTooltip({ field: key }) + ':'}
                                                                                &nbsp;
                                                                           </td>
                                                                           <td className="content">
                                                                                {`${item[key]}`}
                                                                                {key === 'landingPage' || key === 'referrer' ? (
                                                                                     <a
                                                                                          href={item[key]}
                                                                                          target="_blank"
                                                                                          rel="noopener noreferrer"
                                                                                          style={{ paddingLeft: '10px' }}
                                                                                     >
                                                                                          <CIcon icon="icon-open-website-white" size="sm" />
                                                                                     </a>
                                                                                ) : (
                                                                                     ''
                                                                                )}
                                                                           </td>
                                                                      </tr>
                                                                 ) : null
                                                            ) : key === 'sourceUTMs' || key === 'clickIds' ? (
                                                                 item[key] !== null && item[key].length > 0 ? (
                                                                      item[key].map((i, index) => {
                                                                           return (
                                                                                i['value'] !== null && (
                                                                                     <tr key={`${key}${index}`}>
                                                                                          {Object.keys(i).map((key, keyIndex) => {
                                                                                               return keyIndex ? (
                                                                                                    <td
                                                                                                         key={`${key}${index}`}
                                                                                                         className="content"
                                                                                                    >{`${i[key]}`}</td>
                                                                                               ) : (
                                                                                                    <td key={`${key}${index}`} className="title3">
                                                                                                         {i[key] + ':'}&nbsp;
                                                                                                    </td>
                                                                                               );
                                                                                          })}
                                                                                     </tr>
                                                                                )
                                                                           );
                                                                      })
                                                                 ) : null
                                                            ) : key === 'timestamp' || key === 'startDate' || key === 'endDate' ? (
                                                                 item[key] !== null && item[key] !== undefined ? (
                                                                      <tr key={`${key}`}>
                                                                           <td className="title2">{getFriendlyNameTooltip({ field: key }) + ':'}
                                                                           &nbsp;</td>
                                                                           <td className="content">{item[key].value ? item[key].value : item[key]}</td>
                                                                      </tr>
                                                                 ) : null
                                                            ) : key === 'noted' ? (
                                                                 item[key] !== null && item[key] !== undefined ? (
                                                                      <tr key={`${key}`}>
                                                                           <td className="content" colSpan="2">
                                                                                <span dangerouslySetInnerHTML={{ __html: item[key] }} />
                                                                           </td>
                                                                      </tr>
                                                                 ) : null
                                                            ) : item[key] !== null && item[key] !== '' ? (
                                                                 <tr key={`${key}`}>
                                                                      {Object.keys(item[key]).map((i, index) => {
                                                                           return index ? (
                                                                                <td key={`${key}${index}`} className="content">{`${item[key][i]}`}</td>
                                                                           ) : (
                                                                                <td key={`${key}${index}`} className="title1">
                                                                                     {item[key][i] + ':'}&nbsp;
                                                                                </td>
                                                                           );
                                                                      })}
                                                                 </tr>
                                                            ) : null)
                                                  )
                                                  :
                                                  <>
                                                       {Object.keys(item).filter((i)=> i !== 'name' && i !== 'color').map(
                                                            (key) => {
                                                                 return item[key] !== null && item[key] !== undefined && key !== 'name' && key !== 'color' && item[key] !== '' ? (
                                                                      <tr key={`${key}`}>
                                                                           <td className="content" style={key === 'value' ? { fontSize: 18 } : {}}>
                                                                                {`${item[key]}`}
                                                                           </td>
                                                                      </tr>
                                                                 ) : null
                                                            }
                                                       )}
                                                  </>
                                        }
                                   </tbody>
                              </table>
                         </div>
                    }
                    placement="top"
                    maxWidth="900px"
                    theme="user-source"
                    hideOnClick="false"
                    delay={[200, null]}
                    interactive="true"
                    appendTo={() => document.body}
               >
                    <span>
                         {originalField === 'enrichType' ?
                              <TagStatus item={nameField} tagUserSourceDetail={true} color={item.color} />
                              :
                              <Tag item={nameField} tagUserSourceDetail={true} />
                         }

                    </span>
               </Tippy>
          </div>
     );
};

const renderTagEmptyDetail = (label, key) => {
     return (
          <div className="tags-wrapper" key={key}>
               <span>
                    <Tag item={label} />
               </span>
          </div>
     );
};

export const UserSourceDetails = (data, { style, className, id, isShowTooltipSource = true, isCapitalize = false, isUpper = false, dataIndex }, path = {}, showTooltip, isHiddenCopy = true) => {
     const { isPath, refCell, originalField } = path;
     if (data == null || data.length === 0 || typeof data === 'string') {
          if (isPath) {
               const newData = typeof data === 'string' ? data.replace(/,/g, ', ') : '';
               return (
                    <td
                         ref={refCell}
                         onClick={showTooltip ? () => showTooltip(refCell, isHiddenCopy) : () => { }}
                         {...{ className }}
                         style={{ ...style, cursor: 'pointer' }}
                         tabIndex={0}
                         data-keyboardnavid={id}
                         title={' '}
                         data-title={newData}
                         className={`${className}`}
                    >
                         <span style={{ pointerEvents: 'none' }}>{!newData || newData.length === 0 ? 'None' : newData}</span>
                    </td>
               );
          } else {
               return (
                    <td style={style} className={`${className} view-detail list-tags`} tabIndex={0} data-keyboardnavid={id}>
                         <span>{!data || data.length === 0 ? 'None' : data}</span>
                    </td>
               );
          }
     }

     let nameField = data?.name || data?.companyName || data?.email || data?.schoolName || data?.title || data?.recommenderName;
     return (
          <td style={style} className={`${className} view-detail list-tags`} tabIndex={0} data-keyboardnavid={id}>
               {
                    <div style={{ display: 'flex', gap: '5px' }}>
                         {data?.length
                              ? data.slice(0, 100).map((item, key) => {
                                   const newItem = filterObjectValuesNotNull(item);
                                   let itemName = item?.name || item?.companyName || item?.email || item?.schoolName || item?.title || item?.recommenderName;
                                   if (isCapitalize) {
                                        itemName = capitalizeFirstLetter(itemName);
                                   }

                                   if (isUpper) {
                                        itemName = itemName ? itemName.toUpperCase() : '';
                                   }
                                   return Object.keys(newItem).length && isShowTooltipSource ? renderTooltipUserSource(newItem, key, originalField) : renderTagEmptyDetail(itemName, key);
                              })
                              : !Object.keys(transformObject(filterObjectValuesNotNull(data))).length && !isShowTooltipSource
                                   ? renderTagEmptyDetail(nameField)
                                   : renderTooltipUserSource(data, null, originalField)}
                    </div>
               }
          </td>
     );
};

// Generic display function for education and otherRoles
export const GroupedItemDisplay = (data, { style, className, id }, type, groupKey) => {
     // Handle null or empty data
     if (!data || data.length === 0 || typeof data === 'string') {
          return (
               <td style={style} className={`${className} view-detail list-tags`} tabIndex={0} data-keyboardnavid={id}>
                    <span>{!data || data.length === 0 ? 'None' : data}</span>
               </td>
          );
     }

     // Handle array data
     if (Array.isArray(data)) {
          const groupedData = groupByField(data, groupKey);

          if (groupedData) {
               return (
                    <td style={style} className={`${className} view-detail list-tags`} tabIndex={0} data-keyboardnavid={id}>
                         <div style={{ display: 'flex', gap: '5px' }}>
                              {Object.entries(groupedData).map(([groupName, itemsList], key) =>
                                   renderGroupedItemTooltip(groupName, itemsList, key, type)
                              )}
                         </div>
                    </td>
               );
          }
     }

     return (
          <td style={style} className={`${className}`} tabIndex={0} data-keyboardnavid={id}>
               <span>None</span>
          </td>
     );
};
//----------------------------------------------------------------

export const TableCellValueUndefined = (isLoading, hasOwnProperty = true) => {
     return isLoading || !hasOwnProperty ? (
          <td>
               <Skeleton />
          </td>
     ) : (
          <td>None</td>
     );
};

export const ReportDuration = (value, { style, className, id }) => {
     return (
          <td {...{ style, className }} tabIndex={0} data-keyboardnavid={id}>
               {convertReportDuration(value)}
          </td>
     );
};

export const ChannelPath = (value, { style, className, id }, refCell, showTooltip, isHiddenCopy = true) => {
     const newData = value ? value.replace(/,/g, ', ') : '';
     const isNone = !newData || newData.length === 0 || newData === 'None';

     if (isNone) {
          return (
               <td
                    {...{ className }}
                    style={style}
                    tabIndex={0}
                    data-keyboardnavid={id}
               >
                    <span>None</span>
               </td>
          );
     }

     return (
          <td
               ref={refCell}
               onClick={() => showTooltip(refCell, isHiddenCopy)}
               {...{ className }}
               style={{ ...style, cursor: 'pointer' }}
               tabIndex={0}
               data-keyboardnavid={id}
               title={' '}
               data-title={newData}
               className={`${className}`}
          >
               <span style={{ pointerEvents: 'none' }}>{newData}</span>
          </td>
     );
};

export const Industries = (value, props) => {
     const { style, className, id } = props;
     const industries = props.dataItem.industries;
     const newIndustries = industries ? industries.split(',') : [];

     if (industries.toLowerCase() === 'none') {
          return (
               <td {...{ style, className }} tabIndex={0} data-keyboardnavid={id}>
                    <span>{value}</span>
               </td>
          );
     }
     return (
          <td {...{ style, className }} className={`view-detail list-tags ${className}`} tabIndex={0} data-keyboardnavid={id}>
               <div className="tags-wrapper">
                    {newIndustries.map((item, index) => (
                         <Tag key={index} item={item} />
                    ))}
               </div>
          </td>
     );
};

export const TagArrayFormat = (value, props) => {
     const { style, className, id } = props;

     if (!value || !Array.isArray(value) || value.length === 0) {
          return (
               <td {...{ style, className }} tabIndex={0} data-keyboardnavid={id}>
                    <span>None</span>
               </td>
          );
     }

     return (
          <td {...{ style, className }} className={`view-detail list-tags ${className}`} tabIndex={0} data-keyboardnavid={id}>
               <div className="tags-wrapper">
                    {value.map((item, index) => (
                         <Tag key={index} item={item} />
                    ))}
               </div>
          </td>
     );
};

export const ConversionValue = (value, { style, className, id }) => {
     const valueStr = typeof value === 'number' ? value.toString() : value;
     return (
          <td {...{ style, className }} tabIndex={0} data-keyboardnavid={id}>
               {valueStr && valueStr.toLowerCase() !== 'none' && valueStr.length > 3
                    ? formatNumberWithCommas(valueStr)
                    : formatNumberWithCommas(value)}
          </td>
     );
};

export const CustomConversionValue = (value, { style, className, id }) => {
     return (
          <td {...{ style, className }} tabIndex={0} data-keyboardnavid={id}>{`${value.toLowerCase() !== 'none' && value.length > 3 ? formatNumberWithCommas(value) : value
               }`}</td>
     );
};

export const SecondaryConversionValueCount = (value, { style, className, id }) => {
     return <td {...{ style, className }} tabIndex={0} data-keyboardnavid={id}>{`${formatNumberWithCommas(Number(value))}`}</td>;
};

export const SalesConversionCount = (props, handleEnterToLink, handleLinkToOtherReport, reportName, originalField) => {
     const { style, className, id, field, dataItem } = props;
     const value = getFieldData(dataItem, field, originalField);
     if (value > 0) {
          return (
               <td
                    style={style}
                    className={`clickable ${className}`}
                    tabIndex={0}
                    data-keyboardnavid={id}
                    onKeyPress={(e) => handleEnterToLink(e)}
                    onClick={() => {
                         return handleLinkToOtherReport(originalField, { ...dataItem }, field);
                    }}
               >{`${formatNumberWithCommas(Number(value))}`}</td>
          );
     }
     return <td {...{ style, className }} tabIndex={0} data-keyboardnavid={id}>{`${formatNumberWithCommas(Number(value))}`}</td>;
};

const renderCellValue = (value) => {
     if (value && typeof value === 'string' && value.includes('\n')) {
          const lines = value.split('\n');
          const maxLines = 2;
          const hasMore = lines.length > maxLines;
          const displayLines = hasMore ? lines.slice(0, maxLines) : lines;
          return (
               <>
                    {displayLines.map((line, i) => (
                         <div key={i} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{line}</div>
                    ))}
                    {hasMore && <div style={{ color: '#888' }}>..(more)</div>}
               </>
          );
     }
     return value;
};

export const TableCellDefault = (value, { style, className, id }, refCell, showTooltip, setRectCell, isMetricField) => {
     return typeof value === 'boolean' ? (
          <td {...{ style, className }} tabIndex={0} data-keyboardnavid={id}>
               <span>{String(value)}</span>
          </td>
     ) : value && (typeof value !== 'number' || !isMetricField) && value !== 'no' && String(value)?.toLocaleLowerCase() !== 'none' && (value.length > 60 || !isMetricField) ? (
          <td
               ref={refCell}
               onClick={(event) => {
                    showTooltip(refCell, false);
                    setRectCell(event.currentTarget.getBoundingClientRect());
               }}
               {...{ style, className }}
               tabIndex={0}
               data-keyboardnavid={id}
               title={' '}
               data-title={value}
          >
               <span style={{ pointerEvents: 'none' }}>{renderCellValue(value)}</span>
          </td>
     ) : (
          <td {...{ style, className }} tabIndex={0} data-keyboardnavid={id}>
               {formatNumber(value)}
          </td>
     );
};

export const IntentPropertyCell = ({ value, props, intentCellState, intentProperty, refCell, originalField, showTooltip, setRectCell, handleRerunIconClick }) => {
     const dispatch = useDispatch();
     const { style, className, id: cellId, dataItem } = props;
     const { id: propertyId, fieldType, object, ruleStatus } = intentProperty;
     const isActiveRule = ruleStatus === 'active';
     const objectId = dataItem[MAPPING_INTENT_OBJECT_ID[object]];
     const intentCellId = objectId + '_' + propertyId;
     const { isVisible, isLoading, isSuccess, error, result } = intentCellState[intentCellId] || {};
     const isInActive = Object.entries(intentCellState).some(([key, value]) => key.includes(objectId) && !key.includes(propertyId) && value.isLoading);
     const intentClassName = classNames('intent-property-cell', { active: isVisible });
     const isTextType = fieldType === INTENT_PROPERTIES_STORE.TEXT;
     const newValue = result || value;

     const handleCellClick = () => {
          if (!isActiveRule || isLoading) return;

          dispatch(updateIntentCell({ objectId, propertyId, cellState: !isVisible ? { isVisible: true } : { isSuccess: false } }));
     };

     const getTooltipText = () => {
          if (isInActive) return 'You can only re-run this property after the re-run process of another property on the same object has been completed.';
          if (isLoading) return 'Processing re-run...';
          if (isSuccess) return 'Re-run successful';
          if (error) return <><strong>Re-run failed</strong><br />{error}</>;
          return <>Re-run AI model for this record’s <strong>{intentProperty.name}</strong></>;
     };

     const reloadIconElement = (
          <Tippy content={<div style={{ padding: '5px', maxWidth: '250px' }}>{getTooltipText()}</div>} placement='top' delay={[200, null]} maxWidth='300px'>
               <div
                    className='intent-property-icon'
                    onClick={(event) => {
                         if (!isInActive && !isLoading && !isSuccess) {
                              event.stopPropagation();
                              handleRerunIconClick({ objectId, propertyId });
                         }
                    }}
               >
                    {isLoading ? (
                         <CSpinner color='primary' size='sm' style={{ width: '1rem', height: '1rem' }} />
                    ) : isSuccess ? (
                         <CIcon icon='cil-check-circle' style={{ color: '#4dbd74' }} />
                    ) : (
                         <CIcon icon='iconReload' style={{ color: isInActive ? '#999999' : error ? '#e55353' : '#63c2de' }} />
                    )}
               </div>
          </Tippy>
     );

     if (!isTextType) {
          if (newValue === null || newValue.length === 0 || typeof newValue === 'string') {
               const _newValue = typeof newValue === 'string' ? newValue.replace(/,/g, ', ') : '';

               return (
                    <td
                         ref={refCell}
                         onClick={() => handleCellClick()}
                         style={style}
                         className={className}
                         tabIndex={0}
                         data-keyboardnavid={cellId}
                         title={' '}
                         data-title={_newValue}
                    >
                         <div className={intentClassName} title={' '}>
                              <span style={{ pointerEvents: 'none' }}>{!_newValue || _newValue.length === 0 ? 'None' : _newValue}</span>
                              {reloadIconElement}
                         </div>
                    </td>
               );
          }

          return (
               <td
                    ref={refCell}
                    onClick={() => handleCellClick()}
                    style={style}
                    className={`${className} view-detail list-tags`}
                    tabIndex={0}
                    data-keyboardnavid={cellId}
               >
                    <div className={intentClassName} title={' '}>
                         <div className='tag-container'>
                              {newValue?.length
                                   ? newValue.slice(0, 100).map((item, key) => {
                                          return renderTagEmptyDetail(item?.name, key);
                                     })
                                   : !Object.keys(transformObject(filterObjectValuesNotNull(newValue))).length
                                   ? renderTagEmptyDetail(newValue?.name)
                                   : renderTooltipUserSource(newValue, null, originalField)}
                         </div>
                         {reloadIconElement}
                    </div>
               </td>
          );
     }

     if (
          newValue &&
          typeof newValue !== 'boolean' &&
          typeof newValue !== 'number' &&
          newValue !== 'no' &&
          String(newValue)?.toLocaleLowerCase() !== 'none' &&
          newValue.length > 60
     ) {
          return (
               <td
                    ref={refCell}
                    onClick={(event) => {
                         showTooltip(refCell, false);
                         setRectCell(event.currentTarget.getBoundingClientRect());
                         handleCellClick();
                    }}
                    style={style}
                    className={className}
                    tabIndex={0}
                    data-keyboardnavid={cellId}
                    title={' '}
                    data-title={newValue}
               >
                    <div className={intentClassName} title={' '}>
                         <span style={{ pointerEvents: 'none' }}>{newValue}</span>
                         {reloadIconElement}
                    </div>
               </td>
          );
     }

     return (
          <td ref={refCell} style={style} className={className} tabIndex={0} data-keyboardnavid={cellId} onClick={() => handleCellClick()}>
               <div className={intentClassName} title={' '}>
                    {typeof newValue === 'boolean' ? <span>{String(newValue)}</span> : formatNumber(newValue)}
                    {reloadIconElement}
               </div>
          </td>
     );
};

IntentPropertyCell.propTypes = {
     value: PropTypes.any,
     props: PropTypes.object,
     intentCellState: PropTypes.object,
     intentProperty: PropTypes.object,
     refCell: PropTypes.any,
     originalField: PropTypes.string,
     showTooltip: PropTypes.func,
     setRectCell: PropTypes.func,
     handleRerunIconClick: PropTypes.func
};

Tag.propTypes = {
     item: PropTypes.any,
     tagUserSourceDetail: PropTypes.any,
     onClick: PropTypes.func,
};

TagStatus.propTypes = {
     item: PropTypes.any,
     tagUserSourceDetail: PropTypes.any,
     color: PropTypes.string,
     onClick: PropTypes.func,
};
